module.exports = __webpack_public_path__ + "img/progressBar-processing.ea4edbe1.png";